import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FlaskConical, Loader2 } from 'lucide-react';

interface BetaSettingsProps {
  asrModelPreference: string | null;
  setAsrModelPreference: (value: string | null) => void;
  streamingDictation: boolean;
  setStreamingDictation: (enabled: boolean) => void;
  onSave: () => void;
  isSaving: boolean;
}

export const BetaSettings = ({
  asrModelPreference,
  setAsrModelPreference,
  streamingDictation,
  setStreamingDictation,
  onSave,
  isSaving,
}: BetaSettingsProps) => {
  return (
    <Card className="border-amber-200 bg-amber-50/50">
      <CardHeader>
        <div className="flex items-center gap-2 text-amber-800">
          <FlaskConical className="h-5 w-5" />
          <CardTitle className="text-lg">Beta stillingar</CardTitle>
        </div>
        <CardDescription className="text-amber-700">Prófunarstillingar fyrir beta notendur.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label className="text-amber-900">Talgreiningarlíkan</Label>
          <p className="mb-2 text-amber-700 text-sm">Veldu hvaða talgreiningarlíkan er notað við upptöku</p>
          <Select
            value={asrModelPreference || 'default'}
            onValueChange={(value) => setAsrModelPreference(value === 'default' ? null : value)}
          >
            <SelectTrigger className="w-full sm:w-[300px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="default">Grunnlíkan</SelectItem>
              <SelectItem value="turbo">Turbo líkan (hraðvirkara)</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-start gap-2">
          <Checkbox
            id="streaming-dictation"
            checked={streamingDictation}
            onCheckedChange={(value) => setStreamingDictation(value === true)}
            className="mt-0.5"
          />
          <div className="grid gap-0.5">
            <Label htmlFor="streaming-dictation" className="cursor-pointer text-amber-900">
              Diktera með streymi
            </Label>
            <p className="text-amber-700 text-xs leading-relaxed">
              Notar nýtt streymisviðmót við talgreiningu — hraðari niðurstöður meðan á upptöku stendur. Stilling vistuð
              á þessum vafra.
            </p>
          </div>
        </div>

        <Button onClick={onSave} disabled={isSaving} className="w-full sm:w-auto">
          {isSaving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Vista stillingar
        </Button>
      </CardContent>
    </Card>
  );
};
